import { Component, AfterViewInit,ViewChild, OnInit, ɵConsole } from '@angular/core';
import {  ModalController} from '@ionic/angular';
import { CommonService } from 'src/service/common.service';
import { MessageclientService } from '../../service/messageclient.service';
import { DatePipe } from '@angular/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../model/common';
declare var app;
@Component({
  selector: 'app-schedulingapproval',
  templateUrl: './schedulingapproval.page.html',
  styleUrls: ['./schedulingapproval.page.scss'],
})
export class SchedulingapprovalPage implements AfterViewInit {
 obj:any={};
 fm:any={};
  
  /**
   * 所有日程
   */
  scheduleDate = [];
  scheduleDateString = "";
  storeArray:Array<string> = [];//门店列表
  storeArrayType:Array<any> = [];//门店类型
  searchDate: any = null;//每次获取列表查询日期
  initGetData:boolean = true;
  /** 
   * 当前选中日程
  */
  schedulingSummaryObj:any = {};//排班统计信息
  isAndroid4:boolean = false;//是否是安卓4以下
  isAndroid5Down:boolean = false;//是否是安卓5以下
  isAndroid5:boolean = false;//是否是安卓5
  typeselect:any; // 名称
  remarkShow:boolean = false; // 是否显示备注输入框
  selectValue:any; //  排版类型
  stordValue:any; //  门店类型
  FK_Store_ID:any; // 门店id
  constructor(
    public com: CommonService,
    public modalCtrl:ModalController,
    private msg: MessageclientService,
    private http: HttpCustomerService
  ) {
    this.fm.SNStartDate="00:00";
    this.fm.SNEndDate="00:00";
    this.fm.FK_TBScheduleType_ID="";
    this.fm.FK_Store_ID="";
    this.fm.Remark="";// 填写备注字段
   }

  ngAfterViewInit() {
    const that=this;
    that.obj=that["items"];
    console.log(that.obj);
    that.selectValue= that.obj["TypeName"];
    that.stordValue = that.obj["Name"];
    if(that.obj["Remark"]){
      that.fm.Remark=that.obj["Remark"];
    }
    let datepipe =new DatePipe("en-US");
    let format:any="HH:mm";//过滤当前日期格式
    that.fm.SNStartDate = datepipe.transform(that.obj["SNStartDate"].replace(/-/g, "/"),format);;//SNStartDate
    that.fm.SNEndDate = datepipe.transform(that.obj["SNEndDate"].replace(/-/g, "/"),format);//that.obj["SNEndDate"];
    that.fm.FK_TBScheduleType_ID=that.obj["FK_TBScheduleType_ID"];
    that.fm.FK_Store_ID=that.obj["FK_Store_ID"];
    that.FK_Store_ID = that.obj["FK_Store_ID"];
    if(that.selectValue== "年假" || that.selectValue== "病假" || that.selectValue== "调休" || that.selectValue== "其他"){
      that.remarkShow = true;
    }else{
      that.remarkShow = false;
    }
    that.bondStoreInfop();
    that.bondStoreInfoType();
  }
  dismissModal(){
    const that=this;
    that.modalCtrl.dismiss({
      "result": null
    });
  }
  comfireModal(){
    const that=this;
    that.obj=Object.assign(that.obj,that.fm);
    that.modalCtrl.dismiss({
      "result":  that.obj
    });
  }


  /**
 * 门店类型
 */
bondStoreInfoType(){
  const that=this;
  // UserJurisdictionStoreRelation
  let body = new WebParameterContext();
  body.ConfigName="TBScheduleTypeXML";
  body.OpType = "query";
  body.ConfigType = "view";
  body.Client.PageName = "TBScheduleTypeXML";
  body.Client.ApiType = "Element";
  body.Client.Name = "TBScheduleTypeXML";
  body.Client.ClientType = 2;
  body.RequestBody={};
  body.RequestBody= {"a_Code":{"Value":"T008","CompareOperator":"<>","Type":"CompareValue"}};
  body.RequestBody=JSON.stringify(body.RequestBody);
  that.msg.Loading("数据加载中...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
        that.storeArrayType=data.Status.Datas;
        that.obj.FK_TBScheduleType_ID=that.obj["FK_TBScheduleType_ID"];
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
    loads.present();
  });
  
}
 /**
   * 查看日程详情
   * @param item 选中的日程
   */
  // scheduleDetail(item) {
  //   this.router.navigateByUrl("/tabs/contact/CalendarForm/view/" + item['id']);
  // }
  bondStoreInfop(){
    const that=this;
    // UserJurisdictionStoreRelation
    let body = new WebParameterContext();
    body.ConfigName="UserJurisdictionStoreRelation";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = "UserJurisdictionStoreRelation";
    body.Client.ApiType = "Element";
    body.Client.Name = "UserJurisdictionStoreRelation";
    body.Client.ClientType = 2;
  
    body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id });
    that.msg.Loading("数据加载中...").then(loads=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        loads.dismiss();
        if (data.ResponseMessage.Success) {
          that.storeArray=data.Status.Datas;
          that.obj.FK_Store_ID=that.obj["FK_Store_ID"];
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      })
      loads.present();
    });
    
  }
  // 选中的排版类型
typechange(type){
  const that =this;
  //debugger
  that.storeArrayType.forEach(item => {
    if ( item["a_ID"] == type) {
      that.selectValue =item["a_TypeName"];
    }
  })
  that.storeArrayType.forEach(function (item, i) {
      console.log(item["a_Code"],"显示的东西");
      if(type == item["a_ID"]){
        that.typeselect = item["a_TypeName"];
      }
      
    })
    console.log( that.typeselect,"名称");
    if(that.selectValue== "年假" || that.selectValue== "病假" || that.selectValue== "调休" || that.selectValue== "其他"){
      that.remarkShow = true;
    }else{
      that.remarkShow = false;
    }
  
}
// 门店匹配
stordchange(id){
  const that =this;
  debugger;
  that.storeArray.forEach(item => {
    if (item["a_ID"] == id) {
      that.stordValue =item["b_Name"];
      that.FK_Store_ID = item["a_FK_Store_ID"];
    }
  })
}
// 返回
goBack(){
  const that = this;
  that.modalCtrl.dismiss({
    "result": null
  });
}
EventSubmit(event){
  const that=this;
  debugger;
  if(that.selectValue=="年假" || that.selectValue=="病假" || that.selectValue=="调休" || that.selectValue== "其他"){
     if(!that.fm["Remark"]){
       that.msg.Alert("申请原因必填");
       return;
     }
  }else{
    if(that.obj["Remark"]){
      that.obj["Remark"]="";
    }
  }
  const num2:number =parseInt(that.fm["SNStartDate"].replace(':',""));
  const num1:number = parseInt(that.fm["SNEndDate"].replace(':',""));
  if((num1-num2)<=0){
    that.msg.Alert("结束时间不能小于等于开始时间");
    return;
  }
  that.fm["SNStartDate"]=that.obj["SNStartDate"].split(" ")[0]+" "+that.fm["SNStartDate"]+":00";
  that.fm["SNEndDate"]=that.obj["SNEndDate"].split(" ")[0]+" "+that.fm["SNEndDate"]+":00";
  that.fm["TypeName"]=that.selectValue;
  that.fm["Name"]=that.stordValue;
  that.fm["FK_Store_ID"] = that.FK_Store_ID;
  
  var oDate1 = new Date(that.fm["SNStartDate"]);//开始日期
  var oDate2 = new Date(that.fm["SNEndDate"]);//结束日期

  that.obj=Object.assign(that.obj,that.fm);
  that.modalCtrl.dismiss({
    "result":  that.obj
  });
}
}
